import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IAnalyticsState } from 'src/app/state-management/states/aumye-analytics.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromAnalyticsActions from 'src/app/state-management/actions/analytics.actions';
import { AnalyticsInformationDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/analytics-information-dialog/analytics-information-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { IRiskQuestions } from 'src/app/models/riskProfile';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
// import { CreateRiskQuestions } from 'src/app/services/simulation/aumyeSim.utils';
import * as fromUserProfileActions from 'src/app/state-management/actions/user-profile.actions';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-analytics-container',
  templateUrl: './analytics-container.component.html',
  styleUrls: ['./analytics-container.component.scss'],
})
export class AnalyticsContainerComponent implements OnInit {
  destroyed$: Subject<any> = new Subject<any>();
  analyticsState$: Observable<IAnalyticsState>;
  analyticsState: IAnalyticsState;
  dashboardState$: Observable<IDashboardState>;
  dashboardState: IAnalyticsState;
  @ViewChild('AnswerSavingDialog', { static: true })
  answerSavingDialog: TemplateRef<any>;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  dialogOpened = false;
  orgid: string = null;
  constructor(
    private store: Store<IAumyeState>,
    private dialog: MatDialog,
    private _screenSize: AumyeResponsiveScreenService,
    private encryptionService: EncryptionService
  ) {
    this.orgid = this.encryptionService.getCurrentUser().organizationID;
    if (this.orgid != '766773b7-51e9-4951-a2de-6245e6233758') {
      this.analyticsState$ = this.store.select('aumyeAnalyticsState');
      this.analyticsState$
        .pipe(takeUntil(this.destroyed$))
        .subscribe((data) => {
          this.analyticsState = data;
        });
      if (
        this.analyticsState.status.isRiskAnalyticsDataLoaded &&
        (this.analyticsState.riskQuestions == null ||
          this.analyticsState.riskQuestions.length == 0)
      ) {
        // setTimeout(() => {
        //   if (!this.dialogOpened) this.onAnalyticsInformation();
        // }, 3000);
      }
    } else {
      this.dashboardState$ = this.store.select('aumyeDashboardState');
      this.dashboardState$
        .pipe(takeUntil(this.destroyed$))
        .subscribe((data) => {
          this.analyticsState = data.orgRiskData;
        });
      let isLoaded = localStorage.getItem('IsQuestionsAnswered');
      if (isLoaded != 'true') {
        // setTimeout(() => {
        //   if (!this.dialogOpened) this.onAnalyticsInformation();
        // }, 2000);
      }
    }
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ngOnInit(): void {
    this.store.dispatch(new fromAnalyticsActions.InitAnalyticsTab({}));
    this.store.dispatch(new fromAnalyticsActions.GetRiskProfile({}));
  }
  onCreateVisitorTicket(val: any) {
    this.store.dispatch(new fromAnalyticsActions.CreateVisitorTicket(val));
  }
  onCreateIncidentTicket(val: any) {
    this.store.dispatch(new fromAnalyticsActions.CreateIncidentTicket(val));
  }
  onReAnswerAnalytics() {
    const dialogRef = this.dialog.open(AnalyticsInformationDialogComponent, {
      disableClose: false,
      backdropClass: 'analytics-backdrop',
    });
    dialogRef.afterClosed().subscribe((res: FormGroup[]) => {
      if (res) {
        this.dialog.open(this.answerSavingDialog, {
          disableClose: true,
        });
        const riskProfileData: {
          criticality: number;
          frequency: number;
          title: string;
          total: number;
        }[] = [];
        res.forEach((x) => riskProfileData.push(x.value));

        this.store.dispatch(
          new fromUserProfileActions.UpdateRiskProfileQuestions(riskProfileData)
        );
      }
    });
  }
  onAnalyticsInformation(res: any) {
    this.dialog.open(this.answerSavingDialog, {
      disableClose: true,
    });
    const riskProfileData: {
      criticality: number;
      frequency: number;
      title: string;
      total: number;
    }[] = [];
    res.forEach((x: any) =>
      riskProfileData.push({
        criticality: x.criticality,
        frequency: x.numberOfTime,
        title: x.title,
        total: x.totalScore,
      })
    );
    console.log(riskProfileData, 'riskProfileData');
    this.store.dispatch(
      new fromAnalyticsActions.SaveRiskProfileQuestions(riskProfileData)
    );
  }
}
